import React from 'react';
import { TreeNodeType } from '../../../../../../lib/types/types';
import AbschlussAbschlussMesse, { getFormStrucAbschlussAbschlussMesse } from './content/AbschlussAbschlussMesse';
import AllgemeinAbschlussMesse, { getFormStrucAllgemeinAbschlussMesse } from './content/AllgemeinAbschlussMesse';
import BeschreibungAbschlussMesse, { getFormStrucBeschreibungAbschlussMesse } from './content/BeschreibungAbschlussMesse';

export const TreeStructureAbschlussMesse = (application: any): TreeNodeType[] => {
	let treeNodes: TreeNodeType[] = [
		{
			label: 'Allgemein',
			content: <AllgemeinAbschlussMesse />,
			formStruc: getFormStrucAllgemeinAbschlussMesse(),
		},
		{
			label: 'Beschreibung',
			content: <BeschreibungAbschlussMesse />,
			formStruc: getFormStrucBeschreibungAbschlussMesse(application),
		},
		{
			label: 'Abschluss',
			content: <AbschlussAbschlussMesse />,
			formStruc: getFormStrucAbschlussAbschlussMesse(),
		},
	];

	return treeNodes;
};
